'use strict';

export default function f($http, utils, userModel) {
  'ngInject';
  function getApiUrl(offender_id) {
    return utils.getApiUrl(`/reports/${userModel.item.id}/${offender_id}`);
  }

  return {
    reportMessage: '',
    sendReport: function (conversation, message) {
      var data;
      if (message.$type === 'message') {
        data = {
          content: message.content,
          id: message.id,
          type: message.$type,
          report : this.reportMessage
        };
      } else if (message.$type === 'booking') {
        data = {
          bookingId: message.bookingId,
          type: message.$type,
          contentResponse: message.data.responseMessage && message.data.responseMessage.content,
          contentRequest: message.data.requestMessage && message.data.requestMessage.content,
          report : this.reportMessage
        };
      }

      return $http.post(getApiUrl(conversation.id), data);
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/report.service.js